import gql from "graphql-tag"

export const SEARCH_QUERY = gql`
  query searchProducts($where: ProductWhereInput) {
    products(where: $where, first: 25) {
      id
      tds
      name
      purchase
      ltv_max
      mortgage_amount
      rate {
        rate
      }
      lender {
        name
        logo_path
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/containers/rates/rates.queries.js